/**
 * 检测是否为移动设备
 */
export const DeviceUtils = {
  isMobile(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
    return mobileRegex.test(userAgent)
  }
}
